// src/components/pages/HomePage.js
// 다른 메뉴(Expertise/Solution)와 동일한 레이아웃: 이미지 풀와이드 → 검은 배경 설명 블록 → 그래픽 카드 그리드
// 텍스트는 uiConfig.js 의존을 없애고 이 파일에 직접 작성 (수정 시 이 파일만 고치면 됩니다)
import React from 'react';
import { Box, Grid } from '@mui/material';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import StorageIcon from '@mui/icons-material/Storage';
import PsychologyIcon from '@mui/icons-material/Psychology';
import HeroBanner from '../common/HeroBanner';
import DescriptionBlock from '../common/DescriptionBlock';
import FeatureCard from '../common/FeatureCard';

const TITLE = '친환경 먹거리를 위한 AI 기반의 미래 스마트 솔루션';
const SUBTITLE = 'Abocado와 함께 지속가능한 기술혁신을 경험하세요';
const PARAGRAPH = 'Abocado는 그린메탄올 기반의 자체 전력을 생산하는 에너지 자립형 스마트팜, 디지털트윈으로 어디서나 원격 운영이 가능한 재배 환경, 그리고 AI가 데이터를 분석해 만드는 맞춤형 재배 레시피까지 — 에너지 생산부터 신선한 먹거리가 식탁에 오르기까지의 전 과정을 하나로 연결합니다.';

const FEATURES = [
  {
    icon: FlashOnIcon,
    title: '그린메탄올 연계 기술',
    description: '그린메탄올 기반 에너지로 구동되는 에너지 자립형 스마트팜',
    gradient: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)'
  },
  {
    icon: StorageIcon,
    title: '디지털 트윈',
    description: '원격 재배 관리 및 모니터링',
    gradient: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)'
  },
  {
    icon: PsychologyIcon,
    title: 'AI 기술',
    description: '인공지능 기반 재배 최적화',
    gradient: 'linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)'
  }
];

const HomePage = () => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* 메인 이미지 - 자르지 않고 원본 그대로, 텍스트 오버레이 없음 */}
      <HeroBanner image="/images/home-hero.png" overlay={false} />

      {/* 검은 배경 설명 블록 */}
      <DescriptionBlock title={TITLE} paragraphs={[SUBTITLE, PARAGRAPH]} />

      {/* 그래픽 카드 그리드 */}
      <Box sx={{ p: { xs: 3, md: 5 }, backgroundColor: '#0f172a' }}>
        <Grid container spacing={3} justifyContent="center">
          {FEATURES.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <FeatureCard
                  gradient={feature.gradient}
                  icon={<IconComponent fontSize="inherit" />}
                  title={feature.title}
                  description={feature.description}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default HomePage;
